import script from "./TakeStopProfit.vue?vue&type=script&setup=true&lang=js"
export * from "./TakeStopProfit.vue?vue&type=script&setup=true&lang=js"

import "./TakeStopProfit.vue?vue&type=style&index=0&id=4b2e1f0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2e1f0e"]])

export default __exports__